import { useMemo } from 'react';

import {
    ConsumerGroupsSelect,
    ConsumerGroupsSelectProps,
} from 'src/components/FormComponents/ConsumerGroupsSelect';
import { OrganizationRolePermission } from 'src/domain/organization';
import { buildLeafLabelSuffixByGroupId } from 'src/utils/consumerLabelUtils';
import { useConsumers } from 'src/view/hooks/useConsumers';
import { useCreatorRolePermission } from 'src/view/hooks/useCreatorRolePermission';
import { EventFormValues } from './eventFormModel';

export const EventAttendeeGroupsSelect = ({
    showResidentNames,
    ...props
}: ConsumerGroupsSelectProps<EventFormValues> & {
    showResidentNames: boolean;
}) => {
    const canReadResidents = useCreatorRolePermission(
        OrganizationRolePermission.readResidents,
    );
    const enabled = showResidentNames && canReadResidents;
    const { consumers } = useConsumers({
        organizationId: props.organizationId,
        enabled,
        applyCreatorFilter: true,
    });
    const suffixes = useMemo(
        () =>
            enabled
                ? buildLeafLabelSuffixByGroupId(consumers, undefined, {
                      organizationId: props.organizationId,
                  })
                : undefined,
        [consumers, enabled, props.organizationId],
    );
    return (
        <ConsumerGroupsSelect {...props} leafLabelSuffixByGroupId={suffixes} />
    );
};
